import { Component, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { imageProcessing, ImageSnippet } from '../../../utils/image-processing-utils';
import { sweetAlert } from '../../../utils/swal';
import { takeUntil } from 'rxjs/operators';
import { takeUntilDestroyed } from 'src/app/utils/take-until-destroyed';
import { CorporateService } from '../corporate-service/corporate-service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { getAddressDetails, nonZeroCoordinateValidator, requiredOdometers } from "../../../utils/utils.common";
import { LevelOfServiceService } from '../../level-of-service/service/level-of-service.service';

@Component({
  selector: "app-corporate-add-user",
  templateUrl: "./corporate-add-user.component.html",
  styleUrls: ["./corporate-add-user.component.css"],
})
export class CorporateAddUserComponent implements OnInit, OnDestroy {
  addNewCorporateUser: UntypedFormGroup;
  submitted = false;
  selectedFile: ImageSnippet = null;
  profileImageURL = null;
  corporateUserId = null;
  passwordType = "password";
  passwordToggleFlag = true;
  user;
  corporateUsers = [];
  status = "active"
  odometers;
  spaceTypeList = [];

  constructor(
    private fb: UntypedFormBuilder,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private corporateService: CorporateService,
    private sharedDataService: SharedDataService,
    private levelOfServiceService: LevelOfServiceService
  ) {}

  ngOnInit() {
    this.activatedRoute.params
    .pipe(takeUntil(takeUntilDestroyed(this)))
    .subscribe((params) => {
      this.corporateUserId = params["id"];
    });

    this.addNewCorporateUser = this.fb.group({
      displayName: ["", [Validators.required, Validators.minLength(3)]],
      contactNumber: ["", Validators.required],
      tollFreeNumber: ["", Validators.required],
      address: ["", Validators.required],
      accountStatus: ["", Validators.required],
      // associateTo: ["", Validators.required],
      email: ["", [Validators.required, Validators.email]],
      password: ["", [Validators.required,Validators.minLength(6), Validators.maxLength(16),],],
      latitude: ["", [Validators.required, nonZeroCoordinateValidator()]],
      longitude: ["", [Validators.required, nonZeroCoordinateValidator()]],
      corporateUserId: [""],
      images: [""],
      company: [""],
      fsCode:[""],
      showScheduleTime: [false],
      priority: ["",Validators.required],
      requiredOdometers: [0],
      takeSignaturesOnly:[false],
      requireForm837:[false],
      viewTripOnly:[false],
      applyBrokerReasons:[false],
      displayMode:['signature'],
      companyType:[''],
      brokerId: [''],
      spaceTypes:[[]],
      billingName:[''],
      mailingAddress:[''],

      focalPerson: this.fb.group({
        personeNameOne: [ "" ],
        personNumberOne: [ "" ],
        personeNameTwo: [ "" ],
        personNumberTwo: [ "" ]
      }),
      homeAddress: this.fb.group({
        aptOrSuite: [""],
        zipCode: [""],
        state: [""],
        city: [""],
        street: [""]
      }),
      showTime: ['both'],
      isTripModificationNotAllowed: [false]
    });

    this.getUser();
    this.getOdometerValue();
    this.getcorporateUsers();
    if(this.corporateUserId)
    this.getCorporateUserById(this.corporateUserId);
    this.getSpaceTypes();


  }

  getUser() {
    this.sharedDataService.getUser()
    .pipe(takeUntil(takeUntilDestroyed(this)))
    .subscribe((user) => {

      if (user) {

        this.user = user;
        this.addNewCorporateUser.patchValue({
          company:this.user._id
        })

      }
    });
  }

  get form() {
    return this.addNewCorporateUser.controls;
  }

  getCorporateUserById(id) {
    this.corporateService.getCorporateUserById(id)
    .pipe(takeUntil(takeUntilDestroyed(this)))
    .subscribe((data) => {
      if (data) {
        this.addNewCorporateUser.patchValue({
          ...data,
          password: "",
          company: this.user._id,
        });
        this.profileImageURL = data.profileImageURL;
        if (this.user.isShowCMS1500 === false) {
          this.addNewCorporateUser.patchValue({
            requireForm837: false
          })
        }
      }
      this.addNewCorporateUser.get('password').clearValidators();
      this.addNewCorporateUser.get('password').updateValueAndValidity();

    });
  }

  getSpaceTypes() {
    this.levelOfServiceService
      .getSpaceTypes({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.spaceTypeList = data;
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  processFile(imageInput: any) {
    imageProcessing(imageInput)
    .pipe(takeUntil(takeUntilDestroyed(this)))
    .subscribe((result) => {
      this.selectedFile = result.file;
      this.profileImageURL = result.src;
    });
  }

  getAddress(place) {
    const addressDetails = getAddressDetails(place);
    this.addNewCorporateUser.patchValue({
      address: place.formatted_address,
      latitude: place.geometry.location.lat(),
      longitude: place.geometry.location.lng(),
      homeAddress: {
        ...addressDetails
      }
    });
  }

  togglePasswordType() {
    this.passwordType = this.passwordToggleFlag ? "text" : "password";
    this.passwordToggleFlag = !this.passwordToggleFlag;
  }

  newCorporateUser() {
    this.submitted = true;
    if (this.addNewCorporateUser.invalid) {
      return;
    } else if (this.selectedFile == null && this.profileImageURL == null) {
      return;
    } else {
      const image = {
        newProfilePicture: this.selectedFile,
      };

      // console.clear();
      // return;

      if (!this.corporateUserId) {
        this.addNewCorporateUser.patchValue({
          images: image,
        });
        this.saveCorporateUser(this.addNewCorporateUser.value);
        // this.store.dispatch(new AddCorporateUser(this.addNewCorporateUser.value));
      } else {
        // delete this.addNewCorporateUser.value.password;
        this.addNewCorporateUser.patchValue({
          corporateUserId: this.corporateUserId,
          images: image,
        });
        const payload = this.addNewCorporateUser.value;
        if (this.corporateUserId) {
          if (this.addNewCorporateUser.value.password === '') {
            delete payload.password;
          }
          this.saveCorporateUser(payload);
        }


      }
    }
  }

  saveCorporateUser(payload) {
    this.corporateService.addCorporateUser(payload)
    .pipe(takeUntil(takeUntilDestroyed(this)))
    .subscribe(
      (data) => {
        if (data) {
          this.submitted = false;
          this.router.navigateByUrl('credentialing/fundingsource');
        }
      },
      (err) => {
        sweetAlert("Error", err, "error", "Ok");
      }
    );
  }

  toggleSignature() {
    this.addNewCorporateUser.patchValue({
      takeSignaturesOnly: !this.addNewCorporateUser.value.takeSignaturesOnly
    });
  }

  toggleForm837(){
    this.addNewCorporateUser.patchValue({
      requireForm837: !this.addNewCorporateUser.value.requireForm837
    });

  }
  toggleViewTripOnly(){
    this.addNewCorporateUser.patchValue({
      viewTripOnly: !this.addNewCorporateUser.value.viewTripOnly
    });

  }

  getcorporateUsers() {
    this.corporateService
      .getCorporateUsers(this.status)
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data && data.length) {
          this.corporateUsers = data;
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  getOdometerValue() {
    this.odometers = requiredOdometers;
  }

  onSelectBroker(evt) {
    this.addNewCorporateUser.patchValue({
      companyType: evt
    })

  }

  toggleTripModificationNotAllowed(){
    this.addNewCorporateUser.patchValue({
      isTripModificationNotAllowed: !this.addNewCorporateUser.value.isTripModificationNotAllowed
    });
  }

  toggleApplyBrokerReasons(){
    this.addNewCorporateUser.patchValue({
      applyBrokerReasons: !this.addNewCorporateUser.value.applyBrokerReasons
    });
  }


ngOnDestroy(): void {
}
}
